import * as React from 'react';
import { Route, RouteComponentProps, Switch } from 'react-router';
import CreateEvent from 'src/components/Event/EventManagement/CreateEvent';
import ChooseSection from 'src/pages/Management/EventManagement/ChooseSection';
import ManageOverview from 'src/pages/Management/ManageOverview';
import MyUserManagement from 'src/pages/Management/MyUserManagement/MyUserManagement';
import SeasonManagement from 'src/pages/Management/SeasonManagement/SeasonManagement';
import SectionManagement from 'src/pages/Management/SectionManagement/SectionManagement';
import UserManagement from 'src/pages/Management/UserManagement/UserManagement';
import { NotFound } from 'src/pages/NotFound/NotFound';
import { RoleRights } from 'src/store/user/types';
import { userCan, getUser } from 'src/utils/authHelper';
import { ConditionalRoute } from 'src/utils/routes.helper';
import ClosureView from 'src/pages/Management/Closure/ClosureView';
import ClosureManagementView from 'src/pages/Management/Closure/ClosureManagementView';
import LogsView from 'src/pages/Management/LogView/LogsView';

export const ManageRoutes: React.SFC<RouteComponentProps> = ({ match }) => (
  <Switch>
    <Route exact={true} path={match.url} component={ManageOverview} />

    <Route exact={true} path={`${match.url}/user`} component={MyUserManagement} />

    <ConditionalRoute
      routeCondition={userCan(RoleRights.canManageSections)}
      redirectTo={'/login'}
      exact={true}
      path={`${match.url}/sections`}
      component={SectionManagement}
    />
    <Route exact={true} path={`${match.url}/sections/add`} />
    <Route exact={true} path={`${match.url}/sections/update`} />
    <Route exact={true} path={`${match.url}/sections/delete`} />

    <ConditionalRoute
      routeCondition={userCan(RoleRights.canManageSaisons)}
      redirectTo={'/login'}
      exact={true}
      path={`${match.url}/seasons`}
      component={ChooseSection}
    />
    <Route
      exact={true}
      path={`${match.url}/seasons/:sectionTitle`}
      render={props => <SeasonManagement {...props} />}
    />
    <Route exact={true} path={`${match.url}/seasons/update`} />
    <Route exact={true} path={`${match.url}/seasons/delete`} />

    <Route exact={true} path={`${match.url}/events`} component={ChooseSection} />
    <ConditionalRoute
      routeCondition={userCan(RoleRights.canCreateEvents)}
      redirectTo={'/login'}
      exact={true}
      path={`${match.url}/events/:sectionTitle`}
      component={CreateEvent}
    />
    <Route
      exact={true}
      path={`${match.url}/events/:sectionTitle/add`}
      render={props => <CreateEvent {...props} />}
    />
    <Route exact={true} path={`${match.url}/events/:sectionTitle/update`} />
    <Route exact={true} path={`${match.url}/events/:sectionTitle/delete`} />

    <Route exact={true} path={`${match.url}/users`} component={UserManagement} />

    <ConditionalRoute
      routeCondition={getUser().username === 'superadmin'}
      redirectTo={'/login'}
      exact={true}
      path={`${match.url}/logs`}
      component={LogsView}
    />

    <ConditionalRoute
      routeCondition={getUser().username === 'superadmin'}
      redirectTo={'/login'}
      exact={true}
      path={`${match.url}/closure`}
      component={ClosureView}
    />

    <Route exact={true} path={`${match.url}/closure/manage`} component={ClosureManagementView} />

    <Route component={NotFound} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/routes/manageRoutes.tsx